export default function createGaugeOptions(name, value) {
    return {
        series: [
            {
                name: name,
                type: "gauge",
                z: 3,
                min: 0,
                max: 100,
                axisLine: {
                    lineStyle: {
                        width: 10,
                    },
                },
                detail: { formatter: "{value}%" },
                axisTick: {
                    length: 15,
                    lineStyle: {
                        color: "auto",
                    },
                },
                splitLine: {
                    lineStyle: {
                        color: "transparent",
                    },
                },
                axisLabel: {
                    padding: -10,
                },
                data: [{ value, name: "Socket CPU" }],
                title: {
                    color: "#191D31",
                },
            },
            {
                name: "ChatbotCount",
                type: "gauge",
                center: ["20%", "55%"],
                radius: "50%",
                min: 0,
                max: 100,
                endAngle: 45,
                axisLine: {
                    lineStyle: {
                        width: 8,
                    },
                },
                axisTick: {
                    length: 12,
                    lineStyle: {
                        color: "auto",
                    },
                },
                pointer: {
                    width: 5,
                },
                splitLine: {
                    lineStyle: {
                        color: "transparent",
                    },
                },
                detail: {
                    formatter: "{value} Chatbot",
                    fontSize: 15,
                },
                axisLabel: {
                    padding: -15,
                },
                data: [{ value: 0, name: "Chatbot Count" }],
                title: {
                    color: "#191D31",
                },
            },
            {
                name: "chatCount",
                type: "gauge",
                center: ["78%", "55%"],
                min: 0,
                max: 1000,
                radius: "50%",
                startAngle: 120,
                axisLine: {
                    lineStyle: {
                        width: 8,
                    },
                },
                axisTick: {
                    length: 12,
                    lineStyle: {
                        color: "auto",
                    },
                },
                detail: {
                    formatter: "{value} chat",
                    fontSize: 15,
                },
                axisLabel: {
                    padding: -15,
                },
                splitLine: {
                    lineStyle: {
                        color: "transparent",
                    },
                },
                pointer: {
                    width: 5,
                },
                data: [{ value: 0, name: "Socket Count" }],
                title: {
                    color: "#191D31",
                },
            },
        ],
    };
}
